export const PAGE_NEW = 'new_page';
export const PAGE_DELETE = 'delete_page';
export const PAGE_CLONE = 'page_settings__clone';
export const POST_NEW = 'blog_settings__new_post';
export const POST_CLONE = 'blog_settings__clone_post';
export const POST_DELETE = 'blog_settings__delete_post';
export const POST_PROPERTIES = 'blog_settings__post_properties';
export const BLOG_HOME = 'blog_settings__blog_home';

const defaultPages = [
    'change_slug',
    'change_status',
    PAGE_DELETE
];

const blogOnlyTools = [
    POST_CLONE,
    POST_DELETE,
    POST_PROPERTIES,
]

const productsOnlySection = [
    'course-hero',
    'bundle-hero',
    'subscription-hero',
    'for-this-course-page',
    'for-this-bundle-page',
    'for-this-subscription-page',
];

const blogOnlySections = [
    "Blog"
]

const defaultExcludedSections = [
    // 'Autodata',
    //'Embed',
    'LoginForms',
    // 'Affiliates',
    'for-this-affiliate-page',
    'Topbar',
    'Footer',
];

const authoringToolsConfig = {
    'page': {
        excludedTools: [
            ...blogOnlyTools
        ],
        excludedSections: [
            ...blogOnlySections,
            ...productsOnlySection,
            ...defaultExcludedSections
        ],
        previewLink: "/{slug}",
        authoringLink: "/author/pageseditor?page={slug}",
    },

    'home': {
        excludedTools: [
            ...blogOnlyTools,
            ...defaultPages
        ],
        excludedSections: [
            ...blogOnlySections,
            ...productsOnlySection,
            ...defaultExcludedSections
        ],
        previewLink: "/pages/home",
        authoringLink: "/author/pageseditor?page={slug}&type=home",
    },

    'start': {
        excludedTools: [
            ...blogOnlyTools,
            ...defaultPages
        ],
        excludedSections: [
            ...blogOnlySections,
            ...productsOnlySection,
            ...defaultExcludedSections
        ],
        previewLink: "/start",
        authoringLink: "/author/pageseditor?page={slug}&type=start",
    },

    'courses': {
        excludedTools: [
            ...blogOnlyTools,
            ...defaultPages
        ],

        excludedSections: [
            ...blogOnlySections,
            ...productsOnlySection,
            ...defaultExcludedSections
        ],
        previewLink: "/courses",
        authoringLink: "/author/pageseditor?page={slug}",
    },

    'subscriptions': {
        excludedTools: [
            ...blogOnlyTools,
            ...defaultPages
        ],
        excludedSections: [
            ...blogOnlySections,
            ...productsOnlySection,
            ...defaultExcludedSections
        ],
        previewLink: "/subscriptions",
        authoringLink: "/author/pageseditor?page={slug}",
    },

    'course': {
        excludedTools: [
            ...blogOnlyTools,
            ...defaultPages,
            'clone_page'
        ],
        excludedSections: [
            ...blogOnlySections,
            'bundle-hero',
            'subscription-hero',
            'for-this-bundle-page',
            'for-this-subscription-page',
            ...defaultExcludedSections
        ],
        previewLink: "/course/{slug}",
        authoringLink: "/author/course?courseid={slug}",
    },

    'bundle': {
        excludedTools: [
            ...blogOnlyTools,
            ...defaultPages,
            'clone_page'
        ],
        excludedSections: [
            ...blogOnlySections,
            'course-hero',
            'subscription-hero',
            'for-this-course-page',
            'for-this-subscription-page',
            ...defaultExcludedSections
        ],
        previewLink: "/bundle/{slug}",
        authoringLink: "/author/pageseditor?page={slug}&type=bundle",
    },

    'subscription': {
        excludedTools: [
            ...blogOnlyTools,
            ...defaultPages,
            'clone_page'
        ],
        excludedSections: [
            ...blogOnlySections,
            'course-hero',
            'bundle-hero',
            'for-this-course-page',
            'for-this-bundle-page',
            ...defaultExcludedSections
        ],
        previewLink: "/subscription/{slug}",
        authoringLink: "/author/pageseditor?page={slug}&type=subscription",
    },

    'payment': {
        excludedTools: [
            ...blogOnlyTools,
            ...defaultPages
        ],
        excludedSections: [
            ...blogOnlySections,
            ...productsOnlySection,
            ...defaultExcludedSections
        ],
        previewLink: "/payment",
        authoringLink: "/author/pageseditor?page={slug}&type=payment",
    },

    'thankyou': {
        excludedTools: [
            ...blogOnlyTools,
            ...defaultPages
        ],
        excludedSections: [
            ...blogOnlySections,
            ...productsOnlySection,
            ...defaultExcludedSections
        ],
        previewLink: "/thankyou",
        authoringLink: "/author/pageseditor?page={slug}&type=thankyou",
    },

    'affiliate-registration': {
        excludedTools: [
            ...blogOnlyTools,
            ...defaultPages
        ],
        excludedSections: [
            ...blogOnlySections,
            ...productsOnlySection,
            'LoginForms',
            'Topbar',
            'Footer',
        ],
        previewLink: "/affiliate-registration",
        authoringLink: "/author/pageseditor?page={slug}&type=affiliate-registration",
    },

    'affiliate-program-terms': {
        excludedTools: [
            ...blogOnlyTools,
            ...defaultPages
        ],
        excludedSections: [
            ...blogOnlySections,
            ...productsOnlySection,
            ...defaultExcludedSections
        ],
        previewLink: "/affiliate-program-terms",
        authoringLink: "/author/pageseditor?page={slug}&type=affiliate-program-terms",
    },

    'blog': {
        excludedTools: [
            ...blogOnlyTools,
            ...defaultPages
        ],
        excludedSections: [
            'BlogPostHero',
            'BlogPostMainText',
            ...productsOnlySection,
            ...defaultExcludedSections
        ],
        previewLink: "/blog",
        authoringLink: "/author/pageseditor?page={slug}&type=blog",
    },

    'blog_post': {
        excludedTools: [
            'delete_page',
            'clone_page',
            'change_groups',
            'page_settings__clone',
            'page_settings__clear',
            'page_settings__delete',
            'page_settings__reset'
        ],

        excludedSections: [
            'BlogHomeHeaders',
            'BlogHomePostsLists',
            ...defaultExcludedSections,
            ...productsOnlySection,
        ],
        previewLink: "/blog/{slug}",
        authoringLink: "/author/pageseditor?page={slug}&type=blog_post",
    },

    'terms': {
        excludedTools: [...defaultPages],
        excludedSections: [
            ...blogOnlySections,
            ...productsOnlySection,
            ...defaultExcludedSections
        ],
        previewLink: "/terms",
        authoringLink: "/author/pageseditor?page={slug}",
    },

    'cookies': {
        excludedTools: [...defaultPages],
        excludedSections: [
            ...blogOnlySections,
            ...productsOnlySection,
            ...defaultExcludedSections
        ],
        previewLink: "/cookies",
        authoringLink: "/author/pageseditor?page={slug}&type=cookies",
    },

    'privacy': {
        excludedTools: [...defaultPages],
        excludedSections: [
            ...blogOnlySections,
            ...productsOnlySection,
            ...defaultExcludedSections
        ],
        previewLink: "/privacy",
        authoringLink: "/author/pageseditor?page={slug}",
    }
};

const instructorExcludedTools = [
    'search',
    'new_page',
    'page_settings_click',
    'page_settings__properties',
    'page_settings__seo',
    'page_settings__code',
    'page_settings__clone',
    'page_settings__reset',
    'page_settings__delete',
    'design_settings',
    'site_settings',
    'responsive_settings__set_scale',
];

const instructorExcludedSections = [
    'Topbar',
    'Footer',
    'Embed',
    'Courses',
    'LoginForms',
    "bundles-hero",
    'subscriptions-hero',
    'Payments',
    'Dynamic-Bundles',
    'Dynamic-Subscriptions',
    'Dynamic-Community-Posts',
    'Affiliates'
];

const supportOnlyTools = [
    'export_blog_posts'
];

// Used for vuex actions before running
export const ensurePermission  = (permission, fn) => {
    return (context, payload) => {
        return context.dispatch(
            "authoringSettings/triggerAuthoringTool", { tool: permission }, { root: true }
        ).then(() => {
            fn(context, payload);
        });
    }
}

export default authoringToolsConfig;

export {
    authoringToolsConfig,
    instructorExcludedTools,
    instructorExcludedSections,
    supportOnlyTools
};
